import React, { useEffect, useState } from "react";
import { MdErrorOutline, MdCheckCircle, MdClose } from "react-icons/md";

const ToastMessage = ({
  type = "success",
  message = "",
  onClose,
  duration = 3000,
}) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!message) return;
    setVisible(true);
    const hideTimer = setTimeout(() => {
      setVisible(false);
    }, duration);
    const closeTimer = setTimeout(() => {
      onClose && onClose();
    }, duration + 300);
    return () => {
      clearTimeout(hideTimer);
      clearTimeout(closeTimer);
    };
  }, [message, duration, onClose]);

  if (!message) return null;

  const handleClose = () => {
    setVisible(false);
    setTimeout(() => onClose && onClose(), 300);
  };

  return (
    <div
      className={`fixed top-4 right-4 w-[90%] max-w-md
        transition-all duration-300 ease-out z-[9999]
        ${visible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-4"}
      `}
    >
      <div
        className={`flex items-center gap-3 px-4 py-3.5 rounded-lg shadow-2xl
          backdrop-blur-sm border text-sm font-medium
          ${
            type === "error"
              ? "bg-red-500 border-red-600 text-white shadow-red-500/50"
              : "bg-emerald-500 border-emerald-600 text-white shadow-emerald-500/50"
          }`}
      >
        {/* Icon */}
        <div className="flex-shrink-0">
          {type === "error" ? (
            <MdErrorOutline className="text-xl" />
          ) : (
            <MdCheckCircle className="text-xl" />
          )}
        </div>

        {/* Message */}
        <span className="flex-1 text-left leading-tight">{message}</span>

        {/* Close Button */}
        <button
          onClick={handleClose}
          className="flex-shrink-0 p-1 rounded-full hover:bg-white/20 transition-colors"
          aria-label="Close"
        >
          <MdClose className="text-xl" />
        </button>
      </div>
    </div>
  );
};

export default ToastMessage;